import * as effects from 'redux-saga/effects';
import { Backend } from '../../Backend/Backend';
import { Logger } from '../../Utils/Logger';
import {
	updatePasswordFailed,
	updatePasswordFromEmail,
	updatePasswordFromPrevious,
	updatePasswordSucceed,
} from './Actions';
import { IUpdatePasswordActionTypes } from './Types';

function* handleAskUpdatePasswordFromEmail(
	action: ReturnType<typeof updatePasswordFromEmail>
) {
	const backend = Backend.getInstance();

	try {
		yield effects.apply(
			backend,
			backend.updatePasswordFromEmail,
			action.payload as any
		);
		yield effects.put(updatePasswordSucceed());

		Logger.info('Successfully updating Password');
	} catch (err) {
		yield effects.put(
			updatePasswordFailed(
				"Une erreur s'est produite, veuillez contacter le service client."
			)
		);
		Logger.warn({ err }, 'Failed updating Password');
	}
}

function* handleAskUpdatePasswordFromPrevious(
	action: ReturnType<typeof updatePasswordFromPrevious>
) {
	const backend = Backend.getInstance();

	try {
		yield effects.apply(
			backend,
			backend.updatePasswordFromPrevious,
			action.payload as any
		);
		yield effects.put(updatePasswordSucceed());

		Logger.info('Successfully sending mail');
	} catch (err) {
		yield effects.put(
			updatePasswordFailed('Mauvaise combinaison username et email')
		);
		Logger.warn({ err }, 'Failed sending mail');
	}
}

function* watchAskUpdatePasswordFromEmail() {
	yield effects.takeEvery(
		IUpdatePasswordActionTypes.UPDATE_PASSWORD_FROM_EMAIL,
		handleAskUpdatePasswordFromEmail
	);
}

function* watchAskUpdatePasswordFromPrevious() {
	yield effects.takeEvery(
		IUpdatePasswordActionTypes.UPDATE_PASSWORD_FROM_PREVIOUS,
		handleAskUpdatePasswordFromPrevious
	);
}

export function* UpdatePasswordSaga(): Generator<
	effects.AllEffect<effects.ForkEffect<void>>,
	void
> {
	yield effects.all([effects.fork(watchAskUpdatePasswordFromEmail)]);
	yield effects.all([effects.fork(watchAskUpdatePasswordFromPrevious)]);
}
